import Wrapsody from '../../images/wrapsody.svg'
import WrapsodyEco from '../../images/wrapsodyeco.svg'
import Drm from '../../images/drm.svg'

const data = [[
  {
    img:Wrapsody,
    title:'Content-centric<br/>collaboration',
    sub:"Implement a consolidated approach for content collaboration using information-centric and content virtualization strategies",
    href:"https://en.fasoo.com/products/wrapsody/"
  },
  {
    img:WrapsodyEco,
    title:"Workgroup-based<br/>collaboration",
    sub:"Simplify secure collaboration, and maintain control and visibility of information regardless of how users work",
    href:"https://en.fasoo.com/products/wrapsody-eco/"
  },
  {
    img:Drm,
    title:"Advanced data<br/>security",
    sub:"Enforce the highest level of security using Enterprise DRM solution, and implement a holistic data security strategy",
    href:"https://en.fasoo.com/products/fasoo-enterprise-drm/"
  }],  
]

export default data;